import { useCallback, useMemo } from 'react';

import { useHookResult } from 'pages/funnel/storage/hooks';
import { useAnalyticsService } from 'services/AnalyticsService';

const NEW_CHECKOUT_IDENTIFIER = { type: 'checkout-redesign' };

export const useCheckoutRedesignAnalyticsData = () => {
  const analyticsService = useAnalyticsService();
  const analyticsDataObj = useMemo(() => analyticsService.analyticsData, [analyticsService.analyticsData]);

  const analyticsData = useMemo(() => {
    return {
      userId: analyticsDataObj?.userId,
      matchId: analyticsDataObj?.matchId,
      offerName: analyticsDataObj?.offerName,
      offerValue: analyticsDataObj?.offerValue,
      offerType: analyticsDataObj?.offerType,
    };
  }, [
    analyticsDataObj?.userId,
    analyticsDataObj?.matchId,
    analyticsDataObj?.offerName,
    analyticsDataObj?.offerValue,
    analyticsDataObj?.offerType,
  ]);

  const combinedAnalyticsData = useCallback(() => ({
    ...analyticsData,
    content: {
      ...NEW_CHECKOUT_IDENTIFIER,
    },
  }), [analyticsData]);

  return useHookResult(combinedAnalyticsData);
};
